import styled from 'styled-components'
import theme from 'src/styles/theme'
import { Paper } from '@mui/material'

export const DetailWrapper = styled.div`
  width: 100%;
`

export const DetailHeader = styled.header`
  border-radius: 8px 8px 0px 0px;
  padding: 8px;
  background: ${theme.colors.blue};
  color: ${theme.colors.white};
  font-size: 14px;
`

export const DetailBody = styled(Paper)``

export const DetailRow = styled.div`
  padding: 4px 8px;
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  border-bottom: 1px solid ${theme.colors.gray};
`
